/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateClaimLink201Response,
  CreateClaimLinkRequest,
  ErrorEnvelope,
  Problem,
  UpdateClaimLinkRequest,
} from '../models/index';
import {
    CreateClaimLink201ResponseFromJSON,
    CreateClaimLink201ResponseToJSON,
    CreateClaimLinkRequestFromJSON,
    CreateClaimLinkRequestToJSON,
    ErrorEnvelopeFromJSON,
    ErrorEnvelopeToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    UpdateClaimLinkRequestFromJSON,
    UpdateClaimLinkRequestToJSON,
} from '../models/index';

export interface CreateClaimLinkOperationRequest {
    claimId: number;
    createClaimLinkRequest: CreateClaimLinkRequest;
}

export interface DeleteClaimLinkRequest {
    claimId: number;
    linkId: number;
}

export interface GetClaimLinksRequest {
    claimId: number;
}

export interface UpdateClaimLinkOperationRequest {
    claimId: number;
    linkId: number;
    updateClaimLinkRequest: UpdateClaimLinkRequest;
}

/**
 * ClaimLinksApi - interface
 * 
 * @export
 * @interface ClaimLinksApiInterface
 */
export interface ClaimLinksApiInterface {
    /**
     * Create a new hyperlink associated with a claim
     * @summary Add a link to a claim
     * @param {number} claimId Claim ID
     * @param {CreateClaimLinkRequest} createClaimLinkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimLinksApiInterface
     */
    createClaimLinkRaw(requestParameters: CreateClaimLinkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateClaimLink201Response>>;

    /**
     * Create a new hyperlink associated with a claim
     * Add a link to a claim
     */
    createClaimLink(requestParameters: CreateClaimLinkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateClaimLink201Response>;

    /**
     * Remove a hyperlink from a claim
     * @summary Delete a claim link
     * @param {number} claimId Claim ID
     * @param {number} linkId Link ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimLinksApiInterface
     */
    deleteClaimLinkRaw(requestParameters: DeleteClaimLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Remove a hyperlink from a claim
     * Delete a claim link
     */
    deleteClaimLink(requestParameters: DeleteClaimLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Retrieve all hyperlinks associated with a specific claim
     * @summary Get all links for a claim
     * @param {number} claimId Claim ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimLinksApiInterface
     */
    getClaimLinksRaw(requestParameters: GetClaimLinksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<object>>>;

    /**
     * Retrieve all hyperlinks associated with a specific claim
     * Get all links for a claim
     */
    getClaimLinks(requestParameters: GetClaimLinksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<object>>;

    /**
     * Partially update a hyperlink (label and/or URL)
     * @summary Update a claim link
     * @param {number} claimId Claim ID
     * @param {number} linkId Link ID
     * @param {UpdateClaimLinkRequest} updateClaimLinkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimLinksApiInterface
     */
    updateClaimLinkRaw(requestParameters: UpdateClaimLinkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>>;

    /**
     * Partially update a hyperlink (label and/or URL)
     * Update a claim link
     */
    updateClaimLink(requestParameters: UpdateClaimLinkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object>;

}

/**
 * 
 */
export class ClaimLinksApi extends runtime.BaseAPI implements ClaimLinksApiInterface {

    /**
     * Create a new hyperlink associated with a claim
     * Add a link to a claim
     */
    async createClaimLinkRaw(requestParameters: CreateClaimLinkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateClaimLink201Response>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling createClaimLink().'
            );
        }

        if (requestParameters['createClaimLinkRequest'] == null) {
            throw new runtime.RequiredError(
                'createClaimLinkRequest',
                'Required parameter "createClaimLinkRequest" was null or undefined when calling createClaimLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/links`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClaimLinkRequestToJSON(requestParameters['createClaimLinkRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateClaimLink201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new hyperlink associated with a claim
     * Add a link to a claim
     */
    async createClaimLink(requestParameters: CreateClaimLinkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateClaimLink201Response> {
        const response = await this.createClaimLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a hyperlink from a claim
     * Delete a claim link
     */
    async deleteClaimLinkRaw(requestParameters: DeleteClaimLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling deleteClaimLink().'
            );
        }

        if (requestParameters['linkId'] == null) {
            throw new runtime.RequiredError(
                'linkId',
                'Required parameter "linkId" was null or undefined when calling deleteClaimLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/links/{linkId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"linkId"}}`, encodeURIComponent(String(requestParameters['linkId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a hyperlink from a claim
     * Delete a claim link
     */
    async deleteClaimLink(requestParameters: DeleteClaimLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteClaimLinkRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve all hyperlinks associated with a specific claim
     * Get all links for a claim
     */
    async getClaimLinksRaw(requestParameters: GetClaimLinksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<object>>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimLinks().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/links`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieve all hyperlinks associated with a specific claim
     * Get all links for a claim
     */
    async getClaimLinks(requestParameters: GetClaimLinksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<object>> {
        const response = await this.getClaimLinksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Partially update a hyperlink (label and/or URL)
     * Update a claim link
     */
    async updateClaimLinkRaw(requestParameters: UpdateClaimLinkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling updateClaimLink().'
            );
        }

        if (requestParameters['linkId'] == null) {
            throw new runtime.RequiredError(
                'linkId',
                'Required parameter "linkId" was null or undefined when calling updateClaimLink().'
            );
        }

        if (requestParameters['updateClaimLinkRequest'] == null) {
            throw new runtime.RequiredError(
                'updateClaimLinkRequest',
                'Required parameter "updateClaimLinkRequest" was null or undefined when calling updateClaimLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/links/{linkId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"linkId"}}`, encodeURIComponent(String(requestParameters['linkId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClaimLinkRequestToJSON(requestParameters['updateClaimLinkRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Partially update a hyperlink (label and/or URL)
     * Update a claim link
     */
    async updateClaimLink(requestParameters: UpdateClaimLinkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.updateClaimLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
